module.exports = __webpack_public_path__ + "img/comments-icon.62e207ef.png";